/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Polygon GeoJSON Schema
 * @export
 * @interface PolygonGeoJSON
 */
export interface PolygonGeoJSON {
    /**
     * Type
     * @type {string}
     * @memberof PolygonGeoJSON
     */
    type: string;
    /**
     * Coordinates
     * @type {Array<Array<Array<number>>>}
     * @memberof PolygonGeoJSON
     */
    coordinates: Array<Array<Array<number>>>;
}

/**
 * Check if a given object implements the PolygonGeoJSON interface.
 */
export function instanceOfPolygonGeoJSON(value: object): value is PolygonGeoJSON {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function PolygonGeoJSONFromJSON(json: any): PolygonGeoJSON {
    return PolygonGeoJSONFromJSONTyped(json, false);
}

export function PolygonGeoJSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolygonGeoJSON {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function PolygonGeoJSONToJSON(value?: PolygonGeoJSON | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

